export default __webpack_public_path__ + "static/media/email-info.de0ef6e3.pdf";